import NoNavPage from "@/components/NoNavPage";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { type Section } from "@/types/privacy";

import cookiesContent from "@/data/cookiesContent";

interface SidebarProps {
  sections: Section[];
}

interface CookiesSectionProps {
  section: Section;
}

const Sidebar = ({ sections }: SidebarProps) => (
  <aside className="w-64 bg-white dark:bg-gray-800 p-4 lg:p-6 sticky top-16 h-screen overflow-y-auto">
    <h2 className="text-2xl font-bold mb-4 text-gray-800 dark:text-gray-200">
      Contents
    </h2>
    <ScrollArea className="h-[calc(100vh-8rem)]">
      <nav>
        <ul className="space-y-2">
          {sections.map((section) => (
            <li key={section.id}>
              <a
                href={`#${section.id}`}
                className="text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-gray-100 transition-colors"
              >
                {section.title}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </ScrollArea>
  </aside>
);

const CookiesSection = ({ section }: CookiesSectionProps) => (
  <Card key={section.id} id={section.id}>
    <CardHeader>
      <CardTitle className="text-2xl font-semibold">{section.title}</CardTitle>
    </CardHeader>
    <CardContent>
      {section.content.map((paragraph, index) => (
        <p key={index} className="text-gray-600 dark:text-gray-300 mb-2">
          {paragraph}
        </p>
      ))}
    </CardContent>
  </Card>
);

const CookiesPage = () => {
  return (
    <NoNavPage title="Cookie Details">
      <div className="flex">
        {/* Sidebar */}
        <Sidebar sections={cookiesContent.sections} />

        {/* Main Content */}
        <div className="flex-1 p-6 space-y-6 overflow-y-auto">
          <Card>
            <CardHeader>
              <CardTitle className="text-3xl font-bold">
                {cookiesContent.title}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-600 dark:text-gray-300">
                <strong>Effective Date:</strong> {cookiesContent.effectiveDate}
              </p>
              <p className="mt-4 text-gray-600 dark:text-gray-300">
                {cookiesContent.introduction}
              </p>
            </CardContent>
          </Card>

          {cookiesContent.sections.map((section) => (
            <CookiesSection key={section.id} section={section} />
          ))}

          <Card>
            <CardContent>
              <p className="text-gray-600 dark:text-gray-300">
                {cookiesContent.contactInfo}
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </NoNavPage>
  );
};

export default CookiesPage;
